//Live base ur

export const COMPLIMATE_BASE_URL = "https://backend.complimate.com.au/api/v1/"
export const COMPLIMATE_STATIC_URL = "https://backend.complimate.com.au/"
export const FILE_DOWNLOAD_PREFIX = "https://compliamate-prod.s3.ap-southeast-2.amazonaws.com/"
export const PROFILE_COMPANY_PIC = "https://compliamate-prod.s3.ap-southeast-2.amazonaws.com/"

// Test base ur
//export const COMPLIMATE_BASE_URL = "https://devbackend.complimate.com.au/api/v1/"
//export const COMPLIMATE_STATIC_URL = "https://devbackend.complimate.com.au/"
//export const FILE_DOWNLOAD_PREFIX = "https://compliamate-dev.s3.ap-southeast-2.amazonaws.com/"
//export const PROFILE_COMPANY_PIC = "https://compliamate-dev.s3.ap-southeast-2.amazonaws.com/"

// localhost base ur
//export const COMPLIMATE_BASE_URL = "http://localhost:8000/api/v1/"
//export const COMPLIMATE_STATIC_URL = "http://localhost:8000/"
//export const FILE_DOWNLOAD_PREFIX = "https://compliamate-dev.s3.ap-southeast-2.amazonaws.com/"
//export const PROFILE_COMPANY_PIC = "https://compliamate-dev.s3.ap-southeast-2.amazonaws.com/"

// App URLs
export const APP_URLS = {
  HOME: "/", // Main app home page
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_OTP: "/forgot-password-otp",
  RESET_PASSWORD: "/reset-password",
  DASHBOARD: "/dashboard",
  ASSISTANT: "/assistant",
  PROJECTS: "/projects",
  PROJECT_FORM_RECORDS: "/projects/:projectId/form-records",
  SITES: "/sites",
  SITE_DETAIL: "/sites/:siteId",
  DOCUMENTS: "/documents",
  EMPLOYEES: "/manage-employee/employees",
  EMPLOYEE_DETAILS: "/manage-employee/employees/:employeeId",
  ROLES: "/manage-employee/roles",
  ROLE_PERMISSION: "/manage-employee/role-permission",
  SUBSCRIPTION: "/subscription",
  PROFILE: "/profile",
  WHS_COMPLIANCE_SOFTWARE: "/whs-compliance-software",
  SAFETY_MANAGEMENT_SOFTWARE: "/safety-management-software",
  INCIDENT_MANAGEMENT_SOFTWARE: "/incident-management-software",
  CONTRACTOR_MANAGEMENT: "/contractor-management",
  CONSTRUCTION_SAFETY_COMPLIANCE: "/construction-safety-compliance",
  WHS_COMPLIANCE_AUDIT_SOFTWARE: "/whs-compliance-audit-software",
  AI_COMPLIANCE_ASSISTANT: "/ai-compliance-assistant",
  DIGITAL_WHS_FORMS: "/digital-whs-forms",
  PLANT_EQUIPMENT_REGISTER_SOFTWARE: "/plant-equipment-register-software",
  SWMS_PCBU_COMPLIANCE: "/swms-pcbu-compliance",
  CERTIFICATE_OF_RECOGNITION: "/certificate-of-recognition",
  BLOG: "/blog",
  BLOG_DETAIL: "/blog/:slug",
  DIGITAL_FORM_MANAGEMENT: "/digital-form-management",
  DIGITAL_FORM_USE_TEMPLATE: "/digital-form-management/use-template",
  COMPANY_FORMS: "/company-forms",
  COMPANY_FORM_FILL: "/company-forms/fill",
  COMPANY_FORM_RECORDS: "/company-forms/records",
  COMPANY_FORM_RECORD_VIEW: "/company-forms/records/view",
  ASSET_RECORD: "/asset-record",
  ASSET_RECORD_NEW: "/asset-record/new",
  ASSET_RECORD_DETAIL: "/asset-record/:assetId",
  ASSET_RECORD_EDIT: "/asset-record/:assetId/edit",
  CONTACT_SALES: "/contact-sales",
  STANDALONE_CONTACT_SALES: "/standalone-contact-sales",
  // Stripe Payment URLs (within dashboard)
  CHECKOUT: "/checkout",
  PAYMENT_SUCCESS: "/payment-success",
  PAYMENT_CANCEL: "/payment-cancel"
}

export const getSiteDetailEndpoint = (siteId) => `company/sites/${siteId}`;
export const getBlogDetailEndpoint = (slug) => `blogs/${encodeURIComponent(slug)}`;
export const getBlogDetailUrl = (slug) =>
  APP_URLS.BLOG_DETAIL.replace(':slug', String(slug));
export const getProjectFormRecordsUrl = (projectId) =>
  APP_URLS.PROJECT_FORM_RECORDS.replace(':projectId', String(projectId));
export const getSiteDocumentsEndpoint = (siteId) => `company/sites/${siteId}/documents`;
export const getSiteDocumentDownloadEndpoint = (siteId, documentId) =>
  `company/sites/${siteId}/documents/${documentId}/download`;
export const getSiteDocumentDeleteEndpoint = (siteId, documentId) =>
  `company/sites/${siteId}/documents/${documentId}`;

export const getCompanyUserDocumentsEndpoint = (userId) => `company/users/${userId}/documents`;
export const getCompanyUserDocumentDownloadEndpoint = (userId, documentId) =>
  `company/users/${userId}/documents/${documentId}/download`;
export const getCompanyUserDocumentDeleteEndpoint = (userId, documentId) =>
  `company/users/${userId}/documents/${documentId}`;


// OAuth Client IDs
export const OAUTH_CLIENTS = {
  GOOGLE: "990795911606-0dudbjpgib87loedq38ovvg3e20stul4.apps.googleusercontent.com", // Replace with your actual Google client ID
  MICROSOFT: "fba2adda-3eef-4264-8be9-206478020e48" // Replace with your actual Microsoft client ID
};

// Company Branding Configuration
export const COMPANY_BRANDING = {
  LOGO_URL: "https://complimate.com.au/static/media/logo.a55ca2e3df2aeb710b3f953ac71d4d05.svg",
  PRIMARY_COLOR: "#26C3C0",
  // Theme-based brand colors
  BRAND_COLORS: {
    LIGHT: "#26C3C0",
    DARK: "#26C3C0"
  }
};

// reCAPTCHA Configuration
export const RECAPTCHA_CONFIG = {
  SITE_KEY: "6LdrsQEsAAAAADsFHjpJItB4rNfW9NrHR_doZtAx",
  SECRET_KEY: "6LdrsQEsAAAAAKV8gYzoaS7DUh4YP09U9kUBLqFQ" // For backend verification only
};

// Company API Endpoints
export const COMPANY_API = {
  LOGIN: "company/company/login",
  REGISTER: "company/company/register",
  VERIFY_OTP: "company/company/verify-otp",
  RESEND_OTP: "company/company/resend-otp",
  LOGOUT: "company/company/logout",
  FORGOT_PASSWORD: "company/company/forgot-password",
  VERIFY_OTP_FORGOT_PASSWORD: "company/company/verify-otp-forgot-password",
  RESET_PASSWORD: "company/company/reset-password",
  CHANGE_PASSWORD: "company/users/change-password",
  NOTIFICATION_PREFERENCES: "company/users/notification-preferences",
  SOCIAL_LOGIN: "company/social/login",
  REGION_INDUSTRY_LIST: "company/region-industry-list",
  CHAT_IMAGE_UPLOAD: "company/company/upload-chat-image",
  DELETE_CHAT_IMAGE: "company/company/delete-chat-image",
  MEDIA_PRESIGNED_URL: "company/media/presigned-url",
  MEDIA_DOWNLOAD: "company/media/download",
  COMPLETE_PROFILE: "company/company/complete-profile",
  EDIT_COMPANY: "company/company/edit",
  EDIT_USER_PROFILE: "company/users/edit-profile",
  UPLOAD_DOCUMENT: "company/documents/upload",
  UPLOAD_MULTIPLE_DOCUMENTS: "company/documents/upload-multiple",
  GET_ALL_DOCUMENTS: "company/documents/all",
  DOWNLOAD_DOCUMENT: "company/documents/download",
  GET_FOLDER_LIST: "company/getfolderlist",
  CREATE_FOLDER: "company/createfolder",
  EDIT_FOLDER: "company/editfolder",
  DELETE_FOLDER: "company/deletefolder",
  EDIT_DOCUMENT: "company/documents/edit",
  DELETE_DOCUMENT: "company/documents/delete",
  // Sites Management
  GET_SITES_LIST: "company/sites/list",
  CREATE_SITE: "company/sites/create",
  EDIT_SITE: "company/sites/edit",
  DELETE_SITE: "company/sites/delete",
  // Projects Management
  GET_PROJECTS_LIST: "company/projects/list",
  CREATE_PROJECT: "company/projects/create",
  EDIT_PROJECT: "company/projects/edit",
  DELETE_PROJECT: "company/projects/delete",
  // Task Management
  CREATE_TASK: "company/tasks/create",
  TASKS_LIST: "company/tasks/projecttasklist",
  TASK_ENUMS: "company/tasks/enums",
  TASK_EDIT: "company/tasks/edit",
  TASK_MOVE: "company/tasks/move",
  TASK_DELETE: "company/tasks/delete",
  TASK_UPDATE_STATUS: "company/tasks/update-status",
  TASK_START: "company/tasks/start",
  TASK_END: "company/tasks/end",
  TASK_TIMELOGS: "company/tasks/timelogs",
  TASK_TIMELOGS_EDIT: "company/tasks/timelogs/edit",
  TASK_DETAIL: "company/tasks/detail",
  TASK_ATTACHMENT_DOWNLOAD: "company/tasks/attachments/download",
  TASK_ATTACHMENT_DOWNLOAD_ALL: "company/tasks/attachments/download-all",
  TASK_COMMENT_CREATE: "company/tasks/comments/create",
  TASK_COMMENT_UPDATE: "company/tasks/comments/update",
  TASK_COMMENT_DELETE: "company/tasks/comments/delete",
  ALL_TASKS_LIST: "company/tasks/alltasklist",
  // Employee Management
  GET_ALL_EMPLOYEES: "company/users/list",
  CREATE_EMPLOYEE: "company/users/create",
  UPDATE_EMPLOYEE: "company/users/edit",
  DELETE_EMPLOYEE: "company/users/delete",
  // Asset Records
  CREATE_ASSET_RECORD: "company/assets/create",
  GET_ASSET_RECORDS: "company/assets/list",
  EDIT_ASSET_RECORD: "company/assets/edit",
  DELETE_ASSET_RECORD: "company/assets/delete",
  // Role Management
  GET_ALL_ROLES: "roles/list?user_type=company",
  CREATE_ROLE: "roles/create",
  UPDATE_ROLE: "roles/update",
  EDIT_ROLE: "roles/edit",
  DELETE_ROLE: "roles/delete",
  GET_MODULES_WITH_PERMISSIONS: "company/users/modules-with-permissions",
  // Modules
  GET_MODULES: "modules/list?module_type=company",
  // Subscription Plans
  GET_SUBSCRIPTION_PLAN: "company/getsubscriptionplan",
  GET_MY_SUBSCRIPTION: "company/my-subscription",
  CREATE_SUBSCRIPTION: "company/create-subscription",
  // Dashboard APIs
  GET_DASHBOARD: "company/dashboard",
  GET_ASSIGNED_PROJECTS: "company/dashboard/assigned-projects",
  GET_TODAYS_TASKS: "company/dashboard/todays-tasks",
  GET_NOTIFICATIONS: "company/dashboard/notifications",
  MARK_NOTIFICATION_READ: "company/notifications/:id/read",
  MARK_ALL_NOTIFICATIONS_READ: "company/notifications/mark-all-read",
  // Stripe Payment APIs
  CREATE_STRIPE_CHECKOUT_SESSION: "company/stripe/create-checkout-session",
  CREATE_STRIPE_CHECKOUT_SESSION_FROM_SUBSCRIBER: "company/stripe/create-checkout-session-from-subscriber",
  STRIPE_PAYMENT_SUCCESS: "company/stripe/payment-success",
  RETRIEVE_STRIPE_SESSION: "company/stripe/retrieve-session",
  CANCEL_SUBSCRIPTION: "company/stripe/cancel-subscription",
  DOWNLOAD_INVOICE: "company/stripe/download-invoice",
  // Device Management
  EXPIRE_LAST_DEVICE: "company/company/expire-last-device",
  EXPIRE_DEVICE: "company/company/expire-device",
  // Public Enquiries (no auth)
  ENQUIRIES: "enquiries",
  // Policies (no auth)
  POLICIES: "policies",
  // Public video tutorials (no auth)
  VIDEO_TUTORIALS: "video-tutorials",
  // Public blogs (no auth)
  BLOGS: "blogs",
  // Digital Forms
  DIGITAL_FORM_TEMPLATES: "company/digital-form/templates",
  DIGITAL_FORM_CLIENT_FORMS: "company/digital-form/client-forms",
  DIGITAL_FORM_CLIENT_FORM_INSTRUCTION_FILE: "company/digital-form/client-forms/instruction-file",
  DIGITAL_FORM_ATTACHMENTS_UPLOAD: "company/digital-form/attachments/upload",
  DIGITAL_FORM_SUBMISSIONS_BY_DESTINATION: "company/digital-form/submissions/by-destination"
}

//LIVE WebSocket URLs
export const ASSISTANT_WEBSOCKET = "wss://backend.complimate.com.au/api/v1/ws/askassistant"
export const DIRECT_ASSISTANT_WEBSOCKET = "wss://backend.complimate.com.au/api/v1/ws/directaskassistant"

// test WebSocket URLs
//export const ASSISTANT_WEBSOCKET = "wss://devbackend.complimate.com.au/api/v1/ws/askassistant"
//export const DIRECT_ASSISTANT_WEBSOCKET = "wss://devbackend.complimate.com.au/api/v1/ws/directaskassistant"

// test WebSocket URLs
//export const ASSISTANT_WEBSOCKET = "ws://localhost:8000/api/v1/ws/askassistant"
//export const DIRECT_ASSISTANT_WEBSOCKET = "ws://dlocalhost:8000/api/v1/ws/directaskassistant"


// Helper function to get full URL
export const getApiUrl = (endpoint, params = {}) => {
  let url = `${COMPLIMATE_BASE_URL}${endpoint}`;
  
  // Convert params object to query string
  const queryParams = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  
  // Append query string if it exists
  if (queryParams) {
    url += `?${queryParams}`;
  }
  
  return url;
}

// Helper function to get static asset URL
export const getStaticUrl = (path) => {
  return `${COMPLIMATE_STATIC_URL}${path}`
}

// Helper function to get profile/company picture URL
export const getProfileCompanyPicUrl = (path) => {
  return `${PROFILE_COMPANY_PIC}${path}`
}

// Company logo URL from relative path (same as Sidebar / CompanyProfile)
export const getCompanyLogoUrl = (companyLogo) => {
  if (!companyLogo) return ""
  const logo = String(companyLogo).trim()
  if (!logo) return ""
  if (
    logo.toLowerCase().startsWith("http://") ||
    logo.toLowerCase().startsWith("https://")
  ) {
    return logo
  }
  const base = PROFILE_COMPANY_PIC.endsWith("/")
    ? PROFILE_COMPANY_PIC
    : `${PROFILE_COMPANY_PIC}/`
  try {
    return new URL(logo, base).href
  } catch {
    return getProfileCompanyPicUrl(logo)
  }
}

// Relative company logo path from login session (for presigned-url API)
export const getCompanyLogoPathFromSession = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}")
    return userData?.company_detail?.company_logo || ""
  } catch {
    return ""
  }
}

// Read company logo URL from login session (userData.company_detail.company_logo)
export const getCompanyLogoFromSession = () => {
  return getCompanyLogoUrl(getCompanyLogoPathFromSession())
}